import {
  Flex,
  HeaderIcon,
  StackHeader,
  useScreenSize,
  NaviIconHeartNew,
  NaviIconHeartFilledNew,
  NaviIconSearch,
} from '@banhala/ui-kit';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { isAndroid, useNavigator } from 'shared/src/utils';
import { useMarketRoute } from '../../../../hooks/useMarketRoute';
import Animated, {
  interpolateColor,
  useAnimatedStyle,
  useDerivedValue,
} from 'react-native-reanimated';
import { scheduleOnRN } from 'react-native-worklets';
import { ScrollContext } from '../MarketHomeBanner/context/ScrollContext';
import { useOnPressFavoriteMarket } from '../../hooks/useOnPressFavoriteMarket';
import { useMarketDetail } from '../../queries/useMarketDetail';
import { useMarketBanner } from '../../queries/useMarketBanner';
import { CartIcon } from './CartIcon';
import { useLogClickSearch } from './hooks/useLogClickSearch';
import { MarketCategories } from '../MarketCategories';
import { useHandleBackPressed } from 'shared/src/hooks';
import { useIsFavoriteMarket } from '../../hooks/useIsFavoriteMarket';

export const MarketHomeHeader: React.FC<{
  marketId: number;
  positionY: number;
  showCategoriesStickyView: boolean;
}> = props => {
  const { params } = useMarketRoute<'MarketHome'>();
  const { width: screenWidth } = useScreenSize();
  const { data: marketDetail } = useMarketDetail(props.marketId);
  const { data: marketBanners } = useMarketBanner(props.marketId);

  const logClickSearch = useLogClickSearch();

  const { showBackButton, onPressBack } = useHandleBackPressed(
    params.instanceId,
  );
  const { navigator } = useNavigator();

  const handleSearchClick = useCallback(() => {
    logClickSearch();
    navigator.moveToSearch();
  }, [logClickSearch, navigator]);

  const values = useContext(ScrollContext);

  const [headerStyle, setHeaderStyle] = useState<'transparent' | 'white'>(
    'transparent',
  );
  const [showHeader, setShowHeader] = useState(false);

  const animatedStyle = useAnimatedStyle(() => {
    if (!values.scrollY) return {};

    if (!!marketBanners && marketBanners.length === 0) {
      return {
        backgroundColor: 'rgba(255, 255, 255, 1)',
      };
    }

    return {
      backgroundColor: interpolateColor(
        values.scrollY.value,
        [0, screenWidth * 0.8],
        ['rgba(255, 255, 255, 0)', 'rgba(255, 255, 255, 1)'],
      ),
    };
  });

  useEffect(() => {
    if (marketBanners && marketBanners.length === 0) {
      setHeaderStyle('white');
      setShowHeader(false);
    }
  }, [marketBanners]);

  useDerivedValue(() => {
    if (!values.scrollY) return;

    if (marketBanners && marketBanners.length === 0) {
      // if (headerStyle !== 'white') {
      //   runOnJS(setHeaderStyle)('white');
      //   runOnJS(setShowHeader)(true);
      // }
      if (values.scrollY.value >= screenWidth * 0.15) {
        if (!showHeader) {
          scheduleOnRN(setShowHeader, true);
        }
      }

      if (values.scrollY.value < screenWidth * 0.15) {
        if (showHeader) {
          scheduleOnRN(setShowHeader, false);
        }
      }
      return;
    }

    if (values.scrollY.value > screenWidth * 0.5) {
      if (headerStyle !== 'white') {
        scheduleOnRN(setHeaderStyle, 'white');
        scheduleOnRN(setShowHeader, true);
        // runOnJS()
      }
    }

    if (values.scrollY.value <= screenWidth * 0.5) {
      if (headerStyle !== 'transparent') {
        scheduleOnRN(setHeaderStyle, 'transparent');
        scheduleOnRN(setShowHeader, false);
      }
    }
  });

  const { isFavoriteMarket } = useIsFavoriteMarket(props.marketId);

  const onPressLikeMarket = useOnPressFavoriteMarket({
    sno: props.marketId,
    marketName: marketDetail?.market.name ?? '',
    recommendedMarketList: marketDetail?.market.recommended_markets ?? [],
    favorite: marketDetail?.market.favorite ?? null,
    listId: marketDetail?.market.recommended_market_list_id ?? '',
  });
  // const logClickShare = useLogClickShare();
  //
  // const onPressShare = useCallback(() => {
  //   if (!marketDetail) return;
  //
  //   logClickShare();
  //
  //   Share.share({
  //     message: isAndroid ? marketDetail.market.share_link : undefined,
  //     url: marketDetail.market.share_link,
  //   });
  // }, [logClickShare, marketDetail]);

  // const testGroupB = useExperimentGroup({
  //   sno: 'EXP1509',
  //   targetGroups: ['B'],
  // });
  // const testGroupC = useExperimentGroup({
  //   sno: 'EXP1509',
  //   targetGroups: ['C'],
  // });

  // if (testGroupB) {
  //   return (
  //     <StackHeader
  //       hideBackButton={!showBackButton}
  //       title={marketDetail?.market.name}
  //       onPressBack={onPressBack}
  //       backgroundColor={'white'}
  //       isTranslucent={true}
  //       rightIcons={[
  //         <HeaderIcon
  //           onPress={onPressLikeMarket.action}
  //           customColor={isFavoriteMarket ? 'bg_pink_primary' : undefined}
  //         >
  //           {isFavoriteMarket ? (
  //             <NaviIconHeartFilledNew />
  //           ) : (
  //             <NaviIconHeartNew />
  //           )}
  //         </HeaderIcon>,
  //         <HeaderIcon onPress={onPressShare}>
  //           <IconShare />
  //         </HeaderIcon>,
  //         <CartIcon headerStyle={'white'} />,
  //       ]}
  //     ></StackHeader>
  //   );
  // }

  return (
    <Flex position={'absolute'} left={0} right={0} top={0}>
      <Animated.View style={animatedStyle}>
        <StackHeader
          hideBackButton={!showBackButton}
          title={showHeader ? (marketDetail?.market.name ?? '') : ''}
          onPressBack={onPressBack}
          backgroundColor={headerStyle}
          isTranslucent={true}
          rightIcons={[
            <HeaderIcon
              testID={`마켓즐겨찾기버튼?value=${isFavoriteMarket ? '1' : '0'}`}
              onPress={onPressLikeMarket.action}
              customColor={isFavoriteMarket ? 'bg_pink_primary' : undefined}
            >
              {isFavoriteMarket ? (
                <NaviIconHeartFilledNew />
              ) : (
                <NaviIconHeartNew />
              )}
            </HeaderIcon>,
            // testGroupB ? (
            //   <HeaderIcon onPress={onPressShare}>
            //     <IconShare />
            //   </HeaderIcon>
            // ) : (
            <HeaderIcon onPress={handleSearchClick}>
              <NaviIconSearch />
            </HeaderIcon>,
            // ),

            <CartIcon headerStyle={headerStyle} />,
          ]}
        ></StackHeader>
      </Animated.View>
      {isAndroid && (
        <Flex
          pointerEvents={props.showCategoriesStickyView ? undefined : 'none'}
        >
          <MarketCategories
            marketId={props.marketId}
            positionY={props.positionY}
            isOverlay={true}
            showCategoriesStickyView={props.showCategoriesStickyView}
          />
        </Flex>
      )}
    </Flex>
  );
};
